import { render, staticRenderFns } from "./LivePreview.vue?vue&type=template&id=2bb89e03&scoped=true&"
import script from "./LivePreview.vue?vue&type=script&lang=js&"
export * from "./LivePreview.vue?vue&type=script&lang=js&"
import style0 from "./LivePreview.vue?vue&type=style&index=0&id=2bb89e03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb89e03",
  null
  
)

export default component.exports